import React from "react";
import PropTypes from "prop-types";
import SelectInput from "../../../common/forms/SelectInput";

const ConsultantNameFilter = React.forwardRef((props, ref) => {
  return (
    <SelectInput default="All" label="Name" onChange={props.onChange} options={props.names.sort()} ref={ref} />
  );
});

ConsultantNameFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  names: PropTypes.array.isRequired,
};

export default React.memo(ConsultantNameFilter);
